export interface ChatCommand {
  name: string;
  description: string;
  hasArg?: boolean;
}

interface ChatCommandMenuProps {
  commands: ChatCommand[];
  filter: string;
  onSelect: (cmd: ChatCommand) => void;
  helpText: string;
}

export function ChatCommandMenu({ commands, filter, onSelect, helpText }: ChatCommandMenuProps) {
  const filtered = commands.filter((c) =>
    c.name.startsWith(filter.toLowerCase()),
  );

  // Show help text when just '/' is typed
  if (!filter && helpText) {
    return (
      <div className="chat-command-menu">
        {commands.map((cmd) => (
          <button
            key={cmd.name}
            className="chat-command-item"
            onMouseDown={(e) => {
              e.preventDefault();
              onSelect(cmd);
            }}
          >
            <span className="chat-command-name">/{cmd.name}</span>
            <span className="chat-command-desc">{cmd.description}</span>
          </button>
        ))}
      </div>
    );
  }

  if (filtered.length === 0) return null;

  return (
    <div className="chat-command-menu">
      {filtered.map((cmd) => (
        <button
          key={cmd.name}
          className="chat-command-item"
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(cmd);
          }}
        >
          <span className="chat-command-name">/{cmd.name}</span>
          <span className="chat-command-desc">{cmd.description}</span>
        </button>
      ))}
    </div>
  );
}
